import PropTypes from 'prop-types';
import * as React from 'react';
import { createComponent } from '../core/create-component.js';
import { CollapsibleContent } from './collapsible-content.component.js';
import { CollapsibleSummaryButton } from './collapsible-summary-button.component.js';
import { CollapsibleSummary } from './collapsible-summary.component.js';
import { Collapsible } from './collapsible.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    heading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ])
};
const BasicCollapsible = createComponent({
    displayName: 'BasicCollapsible',
    root: Collapsible,
    propTypes,
    propConfig: {
        wrapChildren (props, _derivedProps, element) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CollapsibleSummary, null, /*#__PURE__*/ React.createElement(CollapsibleSummaryButton, {
                render: typeof props.heading !== 'string' ? (_param)=> {
                    var { children  } = _param, propsInRender = _object_without_properties(_param, [
                        "children"
                    ]);
                    return React.createElement("div", _object_spread({
                        role: "button",
                        tabIndex: 0
                    }, propsInRender), children);
                } : undefined
            }, props.heading)), /*#__PURE__*/ React.createElement(CollapsibleContent, null, element));
        }
    }
});

export { BasicCollapsible };
